/**
 * @file 文档页页右侧锚点菜单
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback, useMemo} from 'react';
import {Menu} from 'antd';
import classNames from 'classnames';

import {IAnchorMenuItem} from './types';
import A from '../../../../../../components/a/A';


const renderSubMenu = (
    menuList: IAnchorMenuItem[],
    selectedKeysSet: Set<string>
) => (
    menuList.map(menuItem => {
        if ((menuItem.children?.length ?? 0) > 0) {
            return (
                <Menu.SubMenu
                    className={classNames({
                        'ant-menu-submenu-title-selected': selectedKeysSet.has(menuItem.key)
                    })}
                    key={menuItem.key}
                    title={
                        <A href={menuItem.link} title={menuItem.title}>
                            {menuItem.title}
                        </A>
                    }
                >
                    {!!menuItem.children && renderSubMenu(menuItem.children, selectedKeysSet)}
                </Menu.SubMenu>
            );
        }
        return (
            <Menu.Item key={menuItem.key}>
                <A href={menuItem.link} title={menuItem.title}>
                    {menuItem.title}
                </A>
            </Menu.Item>
        );
    })
);


export interface IDocRightMenuProps {
    openKeys: string[];
    onOpenChange: (keys: string[]) => void;
    selectedKeys: string[];
    menuList: IAnchorMenuItem[];
}

const RightMenu: React.FC<IDocRightMenuProps> = props => {
    const {
        openKeys,
        selectedKeys,
        onOpenChange,
        menuList
    } = props;

    const selectedKeysSet = useMemo(() => {
        return new Set(selectedKeys);
    }, [selectedKeys]);

    const handleOnOpenChange = useCallback(
        (keys: (string | number)[]) => onOpenChange(keys.map(k => '' + k)),
        [onOpenChange]
    );

    return (
        <React.Fragment>
            {menuList.length > 0
            && (
                <div className="paddle-install-quick-right-menu-index">
                    目录
                </div>
            )}
            <Menu
                className="paddle-install-quick-right-menu"
                mode="inline"
                inlineIndent={14}
                openKeys={openKeys}
                onOpenChange={handleOnOpenChange}
                selectedKeys={selectedKeys}
            >
                {renderSubMenu(menuList, selectedKeysSet)}
            </Menu>
        </React.Fragment>
    );
};

export default RightMenu;
